export const valueList = {
    namespaced: true,
    state() {
        return {
            productTypes: [],
        }
    },
    getters: {
        productTypes: state => state.productTypes
    },
    mutations: {},
    actions: {}
}

